import { c as _c } from "react/compiler-runtime";
import { CameraIcon, CameraVideoTrajectorySmallIcon, VideoFileIcon } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { MarkupsSummaryStat } from "@pages/project-details/project-overview/markups-summary/markups-summary-stat";
/** Amounts of single and VideoMode 360 photos, and of the VideoMode recordings they come from */
export function CapturedDataSummaryStats(t0) {
  const $ = _c(15);
  const {
    stats
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: "column",
      sm: "row"
    };
    t2 = {
      gap: 2
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CameraIcon />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== stats.singleCount) {
    t4 = <MarkupsSummaryStat icon={t3} count={stats.singleCount} label={"Single 360\xB0 photos"} />;
    $[3] = stats.singleCount;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CameraVideoTrajectorySmallIcon />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== stats.videoModeCount) {
    t6 = <MarkupsSummaryStat icon={t5} count={stats.videoModeCount} label={"VideoMode 360\xB0 photos"} />;
    $[6] = stats.videoModeCount;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <VideoFileIcon />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== stats.videoModeSessionCount) {
    t8 = <MarkupsSummaryStat icon={t7} count={stats.videoModeSessionCount} label="VideoMode recordings" />;
    $[9] = stats.videoModeSessionCount;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t6 || $[13] !== t8) {
    t9 = <Stack direction={t1} sx={t2}>{t4}{t6}{t8}</Stack>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}